const routes = [
  {
    path: '/pre-audit',
    name: '',
    redirect:'/pre-audit/list'
  },
  {
    path: '/pre-audit/list',
    name: '',
    meta:{module:'gold_action_manage',menu:'/pre-audit/list',title:'应用预审核'},
    component: () => import('@/views/preAudit/list.vue')
  },
]

export default routes;
